import { Stack } from "@mantine/core";
import { useEffect, useRef } from "react";
import type { ChatTask } from "@/sdk/agent/chat";

import { ChatAlertBanner } from "./ChatAlertBanner/ChatAlertBanner";
import { MessageInput } from "./ChatMessageInput/MessageInput";
import MessageList from "./ChatMessages/MessageList";
import { getChatVariant } from "./ChatQueue/variants";

export default function ChatMessagesContainer({ activeChatTask }: { activeChatTask: ChatTask }) {
    const messageListViewport = useRef<HTMLDivElement>(null);
    const variant = getChatVariant(activeChatTask);

    // biome-ignore lint/correctness/useExhaustiveDependencies: fix later
    useEffect(() => {
        if (messageListViewport.current) {
            messageListViewport.current.scrollTop = messageListViewport.current.scrollHeight;
        }
    }, [variant]);

    return (
        <Stack h="100%" flex={1} justify="flex-end" w="100%" maw="55rem" gap="0" style={{ overflow: "hidden" }}>
            <MessageList key={activeChatTask.id} chatTask={activeChatTask} viewportRef={messageListViewport} />
            <ChatAlertBanner variant={variant} />
            <MessageInput
                key={activeChatTask.chatId}
                chatId={activeChatTask.chatId}
                chatTask={activeChatTask}
                scrollViewportRef={messageListViewport}
            />
        </Stack>
    );
}
